import React, { useEffect, useContext, useRef } from "react";
import heroimg from "../../../../images/LandingPageImage/heroimg.png";
import "../LandingPageCss/MainHome.css";
import google from "../../../../images/LandingPageImage/google.png";
import Navbar from "../common/Navbar";
import MyContext from "../../../../MyContext";
import { Link } from "react-router-dom";

export default function MainHomeSection() {
  const { openFreeTrialModal } = useContext(MyContext);

  const hasAutoOpened = useRef(false);

  useEffect(() => {
    const isLoggedIn = localStorage.getItem("accessToken");

    if (!isLoggedIn && !hasAutoOpened.current) {
      hasAutoOpened.current = true;

      const timer = setTimeout(() => {
        openFreeTrialModal();
      }, 0);

      return () => clearTimeout(timer);
    }
  }, [openFreeTrialModal]);

  return (
    <div className="hero-bg pt-4 pt-md-5 font-inter">
      <Navbar />
      <div className="text-center text-white py-5 px-3">
        <h1 className="fw-semibold font-bricolage display-6 display-lg-4">
          Smart WhatsApp Marketing to Power <br className="d-none d-sm-block" />
          Your Business
        </h1>

        <p className="lead mt-3">
          Connect More, Reply Faster, Interact More, Convert More
        </p>

        <div className="d-flex flex-column flex-sm-row justify-content-center gap-3 mt-4">
          <Link to="/login" className="text-decoration-none">
            <button
              type="button"
              className="btn btn-outline-google   rounded-pill fw-semibold d-flex align-items-center justify-content-center gap-2 px-2 px-sm-3 py-2 w-sm-auto"
              style={{ minHeight: "44px" }}
            >
              <span
                className="rounded-circle bg-white d-flex align-items-center justify-content-center"
                style={{ width: "30px", height: "30px" }}
              >
                <img
                  src={google}
                  alt="Google"
                  className="img-fluid"
                  style={{ width: "18px", height: "18px" }}
                />
              </span>

              <span className="text-nowrap">Start With Google</span>
            </button>
          </Link>
          <button
            onClick={openFreeTrialModal}
            className="btn btn-outline-demo  rounded-pill px-4 py-2 fw-semibold d-flex align-items-center justify-content-center gap-2"
          >
            Book a Demo
          </button>
        </div>
      </div>

      <div className="container pb-5">
        <div className="mx-auto" style={{ maxWidth: "1000px" }}>
          <img src={heroimg} alt="hero" className="img-fluid" />
        </div>
      </div>
    </div>
  );
}
